import { Container, Chip, Typography, Card, CardActionArea, CardMedia, CardContent, Box, Avatar, Skeleton, Fab } from '@mui/material';
import { Facebook, FavoriteBorder, History, Instagram, LinkOutlined, ShareOutlined, Telegram, WhatsApp } from '@mui/icons-material';
import { Carousel } from 'react-responsive-carousel';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { toReal } from '../functions/utils';
import { useState, useEffect } from 'react';

import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import axios from 'axios';
import LoadingComponent from '../components/LoadingComponent';
import Snackbar from '@mui/material/Snackbar';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '@fontsource/roboto/400.css';
import { ButtonMely } from '../components/DesignSystem/ButtonMely';
import { SpacerMely } from '../components/DesignSystem/SpacerMely';


function Home({ onChange, changeConfigs, colorPrimary, colorSecondary, colorTertiary }, props) {

  const { windows } = props;
  const [loading, setLoading] = useState(false);
  const [isSetTagPixel, setIsSetTagPixel] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState(false);
  const [isShare, setIsShare] = useState(false);
  const [hasOrders] = useState(true);
  const [isLogged, setIsLogged] = useState(true);
  const [enableStore, setEnableStore] = useState("");
  const [open, setOpen] = useState(false);
  const [tipoLoja, setTipoLoja] = useState("");
  const [nome, setNome] = useState("");
  const [background, setBackground] = useState("");
  const [urlBase, setUrlBase] = useState("");
  const [items, setItems] = useState(null);
  const [pedido, setPedido] = useState(null);
  const [destaques, setDestaque] = useState(null);
  const [favoritos, setFavoritos] = useState(null);
  const [statusEstabelecimento, setStatusEstabelecimento] = useState("");
  const [deferredPrompt, setDeferredPrompt] = useState();
  const [enabledInstall, setEnabledInstall] = useState();

  const navigate = useNavigate();

  // const handleOpenLoading = () => {
  //   setLoading(true);
  // };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
    handleCloseLoading();
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handlePerfilLoja = () => {
    navigate('/perfil-loja', { replace: true, state: { page: "home", colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } });
  };

  const handleSelectItem = (id, event) => {
    localStorage.setItem('iIts', id);
    onChange(event, "cardapio");
  };

  const handleCardapio = (event) => {
    onChange(event, "cardapio");
  };

  const handlePerfil = (event) => {
    onChange(event, "perfil");
  };

  const handleGetTipoLoja = () => {
    switch (tipoLoja) {
      case "restaurante":
        return <>cardápio</>
      case "loja":
        return <>catálogo</>
      default:
        return <>cardápio</>;
    }
  };

  const container = windows !== undefined ? () => windows().document.body : undefined;

  const handleBackButton = (event) => {
    console.log("VOLTA")
  };

  useEffect(() => {
    // handleOpenLoading();

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event)
    };

    window.addEventListener('popstate', handleBackButton);

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    const userIsLogged = localStorage.getItem('isLogged');
    let urlBase = window.location.href;
    if (urlBase.includes("?")) {
      let arrUrl = urlBase.split("?");
      urlBase = arrUrl[0];
    }

    if (urlBase.includes("itS=")) {
      const arrUrl = urlBase.split("itS=");
      if (!(localStorage.getItem("pS")) || (!isNaN(localStorage.getItem("pS")) && localStorage.getItem("pS") !== arrUrl[1])) {
        localStorage.setItem('iIts', arrUrl[1]);
        localStorage.setItem('pS', arrUrl[1]);
        onChange("", "cardapio");
        return
      }
    }

    if (urlBase.includes("localhost")) {
      urlBase = "https://meurestaurante.mely.online/";
    }

    const disableButtonInstall = localStorage.getItem('DsIApp') === "true";
    setEnabledInstall(disableButtonInstall);

    if (userIsLogged) {
      const id = localStorage.getItem('iUsr');
      if (!id) {
        clearStorage()
      } else {
        getUltimoPedido(urlBase, id);
        setIsLogged(true);
      }
    } else {
      setPedido([])
    }

    setUrlBase(urlBase);
    getConfig(urlBase);
    getProdutos(urlBase);

    handleCloseLoading();

    return () => {
      window.removeEventListener('popstate', handleBackButton);
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFavoritos(localStorage.getItem('fvUsr'));
  }, [favoritos]);

  const setTagPixel = (tagFacebook) => {
    const arrTag = tagFacebook.split("</script>")
    const facebookTag = arrTag[0].replaceAll("<script>", "");
    const imgTag = arrTag[1].replaceAll("<noscript>", "").replaceAll("</noscript>", "").replaceAll("`", "");

    if (imgTag && imgTag.includes("<img") && imgTag.includes("/>") && !isSetTagPixel) {
      var fbScript = document.createElement('script');
      fbScript.innerHTML = facebookTag;
      document.head.appendChild(fbScript);
      var noscript = document.createElement('noscript');
      noscript.innerHTML = imgTag;
      console.log(imgTag)
      document.head.appendChild(noscript);
      setIsSetTagPixel(true)
    }
  }

  const setAnalytics = (tagGoogle) => {
    var scriptElement1 = document.createElement('script');
    scriptElement1.src = "https://www.googletagmanager.com/gtag/js?id=" + tagGoogle;
    scriptElement1.async = true;

    var scriptElement2 = document.createElement('script');
    scriptElement2.innerHTML = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '" + tagGoogle + "');";

    document.head.appendChild(scriptElement1);
    document.head.appendChild(scriptElement2);
  }

  const isMesaRedirect = async () => {
    const urlBase = window.location.href
    if (urlBase.includes("nm=")) {
      const arrUrl = urlBase.split("nm=");
      changeConfigs(true);
      localStorage.setItem('nM', atob(arrUrl[1]));
    } else {
      localStorage.removeItem("nM")
    }
  }

  const clearStorage = () => {
    setIsLogged(false)
    localStorage.removeItem('isLogged');
    localStorage.removeItem('emUsr');
    localStorage.removeItem('pUsr');
    localStorage.removeItem('tUsr');
    localStorage.removeItem('iUsr');
    localStorage.removeItem('nmUsr');
  }

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('Usuário aceitou instalar o aplicativo');
          } else {
            console.log('Usuário cancelou a instalação do aplicativo');
          }
          setDeferredPrompt(null);
        })
        .catch((error) => {
          console.error('Erro: ', error);
        });
    }
  };

  const handleNInstall = () => {
    setEnabledInstall(true);
    localStorage.setItem('DsIApp', true);
  };

  const handleShare = () => {
    setIsShare(true);
    setOpen(true);
  };

  const share = async (id) => {
    let url;

    switch (id) {
      case 1:
        url = `https://www.messenger.com/new/?uri=${urlBase.replaceAll("/api", "")}`
        window.open(url, '_blank');
        break;
      case 2:
        url = `https://api.whatsapp.com/send?text=${urlBase.replaceAll("/api", "")}`
        window.open(url, '_blank');
        break;
      case 3:
        url = `instagram://share?media=${urlBase.replaceAll("/api", "")}&caption=Veja%20só%20isso`
        window.open(url, '_blank');
        break;
      case 4:
        url = `https://telegram.me/share/url?url=${urlBase.replaceAll("/api", "")}&text=Veja%20só%20isso`
        window.open(url, '_blank');
        break;
      case 5:
        url = `${urlBase.replaceAll("/api", "")}`
        try {
          await navigator.clipboard.writeText(url);
          handleSnack("Link copiado com sucesso.")
        } catch (err) {
          handleSnack("Não foi possivel copiar o link")
        }
        break;
      default:
        url = `https://api.whatsapp.com/send?text=${urlBase.replaceAll("/api", "")}`
        window.open(url, '_blank');
        break;
    }
  }

  const getInfos = (url) => {
    axios.post(`${url}/api/avaliacoes.php`, {
      idestabelecimentos: 1
    })
      .then(response => {
        const avaliacoes = response.data
        let notaTotal = 0, countNotas = 0
        if (avaliacoes) {
          for (const avaliacao of avaliacoes) {
            const partes = avaliacao.avaliacao.split(" -- ");
            notaTotal += parseInt(partes[0])
            countNotas++
          }
          notaTotal = notaTotal / countNotas
          notaTotal = notaTotal.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
          localStorage.setItem('MnT', notaTotal);
          return
        }
        localStorage.setItem('MnT', "4,5");
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const getUltimoPedido = (url, idusuarios) => {
    axios.get(`${url}api/ultimo-pedido-usuario.php?idusuarios=${idusuarios}`)
      .then(response => {
        if (response.data) {
          setPedido(response.data)
        }
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const getProdutos = (url) => {
    axios.get(`${url}api/produtos-menu.php?idestabelecimentos=1`, {
      idestabelecimentos: 1
    })
      .then(response => {
        response = response.data
        // verifica o valor a partir
        for (const produto of response) {
          let valorapartir = [], valorapartiratualizado = parseFloat(produto.valor.replace(".", "").replace(",", '.')), ultsubcategoria = "", categoria = produto.categoria, count = -1, nomeatual = produto.nome
          for (const produto of response) {
            const partes = produto.categoria.split(' - ');
            const categoriaNumero = partes[0];
            const categoriaOriginal = partes[1];
            const categoriaProduto = partes.slice(2).join(' - ');
            produto.categoriaNumero = categoriaNumero
            produto.categoriaOriginal = categoriaOriginal
            produto.categoriaProduto = categoriaProduto
            if (produto.status === "P") {
              continue;
            }
            if (produto.estoque !== undefined && produto.estoque === 0) {
              continue;
            }
            if (produto.tipo != null) {
              if (produto.tipo.includes("adicionais") && produto.tipo.includes("true") && (produto.categoriaProduto === nomeatual || produto.categoria === categoria) && (ultsubcategoria === "" || ultsubcategoria !== produto.subcategoria)) {
                count++
                valorapartir[count] = parseFloat(produto.valor.replace(".", "").replace(",", "."))
                ultsubcategoria = produto.subcategoria
              }
              if (produto.tipo.includes("adicionais") && produto.tipo.includes("true") && (produto.categoriaProduto === nomeatual || produto.categoria === categoria) && parseFloat(produto.valor.replace(".", "").replace(",", ".")) < valorapartir[count]) {
                valorapartir[count] = parseFloat(produto.valor.replace(".", "").replace(",", "."))
              }
              if (produto.tipo.includes("opcionais") && produto.tipo.includes("true") && (produto.categoriaProduto === nomeatual || produto.categoria === categoria) && (ultsubcategoria === "" || ultsubcategoria !== produto.subcategoria)) {
                count++
                valorapartir[count] = parseFloat(produto.valor.replace(".", "").replace(",", "."))
                ultsubcategoria = produto.subcategoria
              }
              if (produto.tipo.includes("opcionais") && produto.tipo.includes("true") && (produto.categoriaProduto === nomeatual || produto.categoria === categoria) && parseFloat(produto.valor.replace(".", "").replace(",", ".")) < valorapartir[count]) {
                valorapartir[count] = parseFloat(produto.valor.replace(".", "").replace(",", "."))
              }
            }
          }
          for (const valora of valorapartir) {
            valorapartiratualizado += valora
          }
          produto.valor_apartir = valorapartiratualizado
        }

        // ajusta as categorias
        let ultimaCategoria = "", ultimaSubcategoria = "", ultimoProduto = ""
        for (const produto of response) {
          const partes = produto.categoria.split(' - ');
          const categoriaNumero = partes[0];
          const categoriaOriginal = partes[1];
          const categoriaProduto = partes.slice(2).join(' - ');
          produto.categoriaNumero = categoriaNumero
          produto.categoriaOriginal = categoriaOriginal
          produto.categoriaProduto = categoriaProduto
          produto.subcategoriaOriginal = produto.subcategoria
          if (ultimaCategoria === "" || ultimaCategoria !== produto.categoria) {
            if (!produto.tipo) {
              if (produto.subcategoria !== "" && (ultimaSubcategoria === "" || ultimaSubcategoria !== produto.subcategoria)) {
                ultimaCategoria = produto.categoria
                ultimaSubcategoria = produto.subcategoria
                ultimoProduto = categoriaProduto
                produto.isFirst = "true"
                continue
              } else {
                if (produto.subcategoria === "") {
                  ultimaSubcategoria = produto.subcategoria
                }
                ultimaCategoria = produto.categoria
                ultimoProduto = categoriaProduto
                produto.isFirst = "true"
                continue
              }
            } else {
              if (produto.subcategoria !== "" && (ultimaSubcategoria === "" || ultimaSubcategoria !== produto.subcategoria)) {
                ultimaCategoria = produto.categoria
                ultimaSubcategoria = produto.subcategoria
                ultimoProduto = categoriaProduto
                produto.isFirst = "true"
                continue
              }
            }
          } else {
            if (produto.subcategoria !== "" && (ultimaSubcategoria === "" || ultimaSubcategoria !== produto.subcategoria)) {
              ultimaCategoria = produto.categoria
              ultimaSubcategoria = produto.subcategoria
              ultimoProduto = categoriaProduto
              produto.isFirst = "true"
              continue
            }
          }

          if (produto.tipo) {
            if (categoriaProduto !== ultimoProduto) {
              produto.isFirst = "true"
            }
          }
          ultimoProduto = categoriaProduto

          produto.categoria = ""
          produto.subcategoria = ""
        }

        let destaques = response.filter(item => item.destaque === 'S');

        if (destaques.length === 0) {
          const itensParaMisturar = [...response];
          for (let i = itensParaMisturar.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [itensParaMisturar[i], itensParaMisturar[j]] = [itensParaMisturar[j], itensParaMisturar[i]];
          }
          destaques = itensParaMisturar.slice(0, 3);
        }
        setDestaque(destaques);

        favoritos ? setItems(response.filter(item => favoritos.includes(`"${item.idprodutos}"`))) : setItems([])
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const getConfig = (url) => {
    const urlBase = new URL(url).origin;
    axios.post(`https://gerenciador.mely.online/api/configuracoes-cliente.php`, {
      urlBase: urlBase,
    })
      .then(resp => {
        const response = resp.data;
        if (response && response.length > 0) {
          localStorage.setItem('Mn', response[0].NM_CT);
          localStorage.setItem('tD', response[0].TP_ENT);
          localStorage.setItem('Md', response[0].IDCT_ML);
          localStorage.setItem('UBs', `${urlBase}/api`);
          localStorage.setItem('UMs', response[0].URL_WT);
          localStorage.setItem('vlMnm', response[0].VL_MN);
          localStorage.setItem('eNbS', response[0].ENB_CT === "1");
          localStorage.setItem('eNbB', response[0].ENB_CP === "1");
          localStorage.setItem('eNbM', response[0].ENB_MN === "1");
          localStorage.setItem('tpLj', response[0].TP_CT);
          localStorage.setItem('pGap', response[0].ENB_PG === "1");

          document.title = response[0].NM_CT;
          setNome(response[0].NM_CT)
          response[0].TG_GG ?? setAnalytics(response[0].TG_GG)
          response[0].TG_FC ?? setTagPixel(response[0].TG_FC)
          const favicon = document.querySelector('link[rel="icon"]');
          favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store.png?${new Date().getTime()}`;
          console.log(response[0].BN_PM)
          if (response[0].BN_PM === "customing") {
            setOpen(true)
          }
          //
          setEnableStore(response[0].ENB_CT === "1");
          changeConfigs(false, false, false, "ENABLED", response[0].ENB_CT === "1");
          changeConfigs(false, response[0].ENB_MN === "1");
          setBackground(response[0].IMG_BN);
          setTipoLoja(response[0].TP_CT);
          changeConfigs(false, false, response[0].TP_CT);

          getInfos(urlBase)
          getHorarios(urlBase)
          isMesaRedirect()
        }
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const getHorarios = (url) => {
    axios.post(`${url}/api/horarios.php`, {
      idestabelecimentos: 1,
    })
      .then(response => {
        response = response.data
        
        if(localStorage.getItem("FxEst") === "1") {
          localStorage.setItem('sTA', `<b style="color:#A41D1D">Fechado temporariamente</b>`);
          setStatusEstabelecimento(`<b style="color:#A41D1D">Fechado temporariamente</b>`)
          return
        }

        const horariosArray = response[0].horarios.split(",");
        const d = new Date();
        let diasemana
        if (d.getDay() === 0) {
          diasemana = horariosArray[6]
        } else {
          diasemana = horariosArray[d.getDay() - 1]
        }
        if (diasemana === "Fechado") {
          localStorage.setItem('sTA', `<b style="color:#A41D1D">Fechado</b>`);
          setStatusEstabelecimento(`<b style="color:#A41D1D">Fechado</b>`)
        } else {
          var unix = Math.round(+new Date() / 1000);
          const horarios = diasemana.split(" às ");
          const horario1 = horarios[0].split(":");
          var unix1 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), horario1[0], horario1[1]) / 1000);
          const horario2 = horarios[1].split(":");
          var unix2 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), horario2[0], horario2[1]) / 1000);

          if (parseInt(horario2[0]) < parseInt(horario1[0]) || (horarios[0] === "00:00" && horarios[1] === "00:00")) {
            unix2 += 86400
          }

          const arrTime = localStorage.getItem("tD").split("(")
          const tempo = arrTime[1].replaceAll(")", "")

          if (unix > unix1 && unix < unix2) {
            localStorage.setItem('sTA', `<b style="color:#33540E">Aberto</b> até ${horarios[1]} • ${tempo}`);

            setStatusEstabelecimento(`<b style="color:#33540E">Aberto</b> até ${horarios[1]} • ${tempo}`)
          } else {
            localStorage.setItem('sTA', `<b style="color:#A41D1D">Fechado</b> abre às ${horarios[0]}`);
            setStatusEstabelecimento(`<b style="color:#A41D1D">Fechado</b> abre às ${horarios[0]}`)
          }
        }

      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const handleCardFavoritos = (produto) => {
    return <Card variant="outlined" sx={{ maxWidth: 500, marginRight: "16px", borderRadius: "8px" }} onClick={() => handleSelectItem(produto.idprodutos)}>
      <CardActionArea>
        <CardMedia component="img" height="170" image={`${urlBase.replaceAll("/api", "")}/imagens-produtos/${produto.idprodutos}_0.png?${new Date().getTime()}`} onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = "https://dedicado.mely.online/imagens/placeholder.png";
        }}
        />
        <CardContent style={{ textAlign: "left" }}>
          <Typography gutterBottom style={{ fontSize: "14px", color: "#1B1B1B", marginBottom: "0px", fontWeight: "bold" }} component="div">
            {produto.nome}
          </Typography>
          {produto.valor_desconto && !(toReal(produto.valor_apartir) !== toReal(parseFloat(produto.valor.replaceAll(".", "").replaceAll(",", "."))) && produto.valor_apartir !== 0) && (
            <Typography style={{ fontSize: '12px', color: 'green', fontWeight: "bold" }} component="div">
              <b style={{ textDecoration: "line-through", color: "#1B1B1B" }}>R$ {toReal(parseFloat(produto.valor.replaceAll(".", "").replaceAll(",", ".")))}</b> &nbsp; R$ {toReal(parseFloat(produto.valor.replaceAll(".", "").replaceAll(",", ".")) - parseFloat(produto.valor_desconto.replaceAll(".", "").replaceAll(",", ".")))}
            </Typography>
          )}

          {toReal(produto.valor_apartir) !== produto.valor && produto.valor_apartir !== 0 && (
            <Typography style={{ fontSize: '12px', color: `rgba(${colorPrimary})`, fontWeight: "bold" }} component="div">
              <b style={{ color: "#1B1B1B", fontWeight: "600" }}>A partir de</b> R$ {produto.valor_desconto ? toReal(parseFloat(produto.valor_apartir) - parseFloat(produto.valor_desconto.replaceAll(".", "").replaceAll(",", "."))) : toReal(parseFloat(produto.valor_apartir))}
            </Typography>
          )}

          {produto.tipovalor === "Por pessoa" && produto.valor_apartir !== 0 && (
            <Typography style={{ fontSize: '12px', color: `rgba(${colorPrimary})`, fontWeight: "bold" }} component="div">
              R$ {toReal(parseFloat(produto.valor.replaceAll(".", "").replaceAll(",", ".")))} <b style={{ color: "#1B1B1B" }}>Por pessoa</b>
            </Typography>
          )}

          {!produto.valor_desconto && toReal(produto.valor_apartir) === produto.valor && produto.tipovalor !== "Por pessoa" && (
            <Typography style={{ fontSize: '12px', color: `rgba(${colorPrimary})`, fontWeight: "bold" }} component="div">
              R$ {toReal(parseFloat(produto.valor.replaceAll(".", "").replaceAll(",", ".")))}
            </Typography>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  }

  return (
    <Container>

      <CardMedia component="img" height="120" image={`${urlBase.replaceAll("/api", "")}/imagens/${background}?${new Date().getTime()}`} style={{ position: "absolute", top: "0", left: "0", right: "0" }} onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        currentTarget.src = "https://dedicado.mely.online/imagens/background.png";
      }} />

      {enableStore &&
        <Fab size="small" variant="circular" color="secondary" aria-label="add" style={{ height: "38px", width: "38px", position: "absolute", right: "10px", top: "10px" }} onClick={handleShare}>
          <ShareOutlined style={{ fontSize: "22px" }} />
        </Fab>
      }

      <LoadingComponent open={loading} />

      <Snackbar
        open={openSnack}
        autoHideDuration={3000}
        onClose={handleClose}
        message={msgSnack}
      />

      <SpacerMely height={130} />

      {/* Cabeçalho Restaurante */}

      <Box style={{ display: "flex", alignItems: "center" }}>
        <Box style={{ height: "100%", width: "70px", borderRadius: "4px" }}>
          <Avatar src={`${urlBase.replaceAll("/api", "")}/imagens/logo-store.png?${new Date().getTime()}`} style={{ margin: "auto", width: "70px", height: "70px", fontSize: "15px" }} />

          <SpacerMely height={2} />

        </Box>
        <Box style={{ flexGrow: 1 }}>
          <Typography style={{ fontSize: "16px", color: "#1B1B1B", display: "flex", alignItems: "center", fontWeight: "bold" }}>
            {/* {nota ? (
              <Chip icon={<Star style={{ color: "#FFF", fontSize: "15px", marginTop: "-3px" }} />} label={nota} size="small" style={{ fontWeight: "normal", backgroundColor: "#33540E", color: "#FFF", borderRadius: "4px", fontSize: "11px", paddingTop: "2px" }} />
            ) : (
              <Skeleton animation="wave" height={40} width="45px" />
            )} */}
            {nome ? (
              <Typography style={{ paddingLeft: "10px", fontWeight: "700" }}>{nome}
              </Typography>
            ) : (
              <>
                &nbsp;&nbsp; <Skeleton animation="wave" height={40} width="155px" />
              </>
            )}
          </Typography>
          {statusEstabelecimento ? (
            <>
              <SpacerMely height={2} />
              <Typography style={{ paddingLeft: "10px", fontSize: "11px", color: "#999" }} dangerouslySetInnerHTML={{ __html: statusEstabelecimento }} />
            </>
          ) : (
            <Skeleton animation="wave" height={21} width="100%" />
          )}

          {/* {tempoEntrega ? (
            <>
              <SpacerMely height={10} />
              <Chip variant="outlined" icon={<TimerOutlined style={{ color: "#464444", fontSize: "24px", marginRight: "-2px" }} />} label={tempoEntrega} style={{ color: "#464444", borderRadius: "4px", fontSize: "14px", paddingTop: "2px" }} />
            </>
          ) : (
            <Skeleton animation="wave" height={40} width="100px" />
          )} */}
        </Box>
        <Box style={{ width: "80px", minWidth: "80px" }}>
          <ButtonMely disabled={!enableStore} style={{ fontSize: "10px", paddingTop: 5, paddingBottom: 5, paddingLeft: 5, paddingRight: 5, borderRadius: 6 }} onClick={enableStore ? handlePerfilLoja : console.log("disabled")}>
            VER PERFIL
          </ButtonMely>
        </Box>
      </Box>

      {enableStore !== "" && !enableStore &&
        <Typography style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: "0" }}>
          <Typography style={{ textAlign: "center", fontSize: "14px", color: "rgba(0,0,0,.3)", minWidth: "300px" }}>

            <img alt="inativo" src="https://mely.online/imagens/sad-face.png" style={{ width: 80 }} />

            <SpacerMely height={10} />
            <b style={{ fontSize: 28 }}>Cliente Inativo</b><br />
            Infelizmente o cliente não usa mais o cardápio do Mely.

            <SpacerMely height={20} />

          </Typography>
        </Typography>
      }

      {enableStore &&
        <>
          {deferredPrompt && !enabledInstall && (
            <Box style={{ background: "#F2F2F2", padding: "10px", borderRadius: "8px", display: "flex", alignItems: "center" }}>
              <Typography style={{ fontWeight: "bold", fontSize: "14px", paddingLeft: "5px", flexGrow: 1 }}>Instalar o aplicativo?</Typography>
              <ButtonMely fullWidth={false} variant="outlined" onClick={handleNInstall} style={{ fontSize: "13px", paddingTop: 5, paddingBottom: 5 }}>Não</ButtonMely>
              <SpacerMely width={10} />
              <ButtonMely fullWidth={false} onClick={handleInstall} style={{ fontSize: "13px", paddingTop: 5, paddingBottom: 5 }}>Instalar</ButtonMely>
              <SpacerMely height={14} />
            </Box>
          )}

          <SpacerMely height={10} />

          {!isLogged && !hasOrders && (
            <Typography style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: "0" }}>
              <Typography style={{ textAlign: "center", fontSize: "12px", color: "#999", minWidth: "300px" }}>

                <img alt="sem pedido" src="https://dedicado.mely.online/imagens/no-order.png" />

                <SpacerMely height={10} />

                Você precisa estar logado para ver os seus pedidos. <br />Que tal realizar o login ou cadastrar-se agora?

                <SpacerMely height={20} />

                <ButtonMely variant="text" onClick={handlePerfil}>Ir para o login</ButtonMely>
              </Typography>
            </Typography>
          )}

          {isLogged && !hasOrders && (
            <Typography style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: "0" }}>
              <Typography style={{ textAlign: "center", fontSize: "12px", color: "#999", minWidth: "300px" }}>

                <img alt="sem pedido" src="https://dedicado.mely.online/imagens/no-order.png" />

                <SpacerMely height={10} />

                Você ainda não fez nenhum pedido. <br />Que tal fazer o primeiro agora?

                <SpacerMely height={20} />

                <ButtonMely variant="text" onClick={handleCardapio}>Ir para o {handleGetTipoLoja()}</ButtonMely>
              </Typography>
            </Typography>
          )}

          {hasOrders && (
            <>
              {/* Favoritos */}

              {favoritos && (
                <>
                  <Typography style={{ fontSize: "16px", color: "#1B1B1B", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                    <FavoriteBorder style={{ color: "#1B1B1B", fontSize: "18px" }} />
                    &nbsp; Favoritos
                  </Typography>

                  <SpacerMely height={12} />
                  {items ? (
                    <Carousel centerMode={true} animationHandler={'slide'} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={100} showIndicators={false} showArrows={false} showStatus={false} showThumbs={false}>
                      {items.map((produto) => (
                        handleCardFavoritos(produto)
                      ))}
                    </Carousel>
                  ) : (
                    <Carousel centerMode={true} animationHandler={'slide'} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={100} showIndicators={false} showArrows={false} showStatus={false} showThumbs={false}>
                      <Card variant="outlined" sx={{ maxWidth: 500, marginRight: "16px", borderRadius: "8px" }}>
                        <CardActionArea>
                          <Skeleton animation="rectangular" height={170} width="80%" style={{ marginLeft: "10%" }} />
                          <CardContent style={{ textAlign: "left" }}>
                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>

                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                      <Card variant="outlined" sx={{ maxWidth: 500, marginRight: "16px", borderRadius: "8px" }}>
                        <CardActionArea>
                          <Skeleton animation="rectangular" height={170} width="80%" style={{ marginLeft: "10%" }} />
                          <CardContent style={{ textAlign: "left" }}>
                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>

                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                      <Card variant="outlined" sx={{ maxWidth: 500, marginRight: "16px", borderRadius: "8px" }}>
                        <CardActionArea>
                          <Skeleton animation="rectangular" height={170} width="80%" style={{ marginLeft: "10%" }} />
                          <CardContent style={{ textAlign: "left" }}>
                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>

                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </Carousel>
                  )}
                </>
              )}

              {!favoritos && (
                <>

                  {destaques ? (
                    <>
                      {destaques.length > 0 && (
                        <Typography style={{ fontSize: "16px", color: "#1B1B1B", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                          <FavoriteBorder style={{ color: "#1B1B1B", fontSize: "18px" }} />
                          &nbsp; Mais pedidos
                        </Typography>
                      )}

                      <SpacerMely height={12} />
                      <Carousel centerMode={true} animationHandler={'slide'} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={100} showIndicators={false} showArrows={false} showStatus={false} showThumbs={false}>
                        {destaques.map((produto) => (
                          handleCardFavoritos(produto)
                        ))}
                      </Carousel>
                    </>
                  ) : (
                    <Carousel centerMode={true} animationHandler={'slide'} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={100} showIndicators={false} showArrows={false} showStatus={false} showThumbs={false}>
                      <Card variant="outlined" sx={{ maxWidth: 500, marginRight: "16px", borderRadius: "8px" }}>
                        <CardActionArea>
                          <Skeleton animation="rectangular" height={170} width="80%" style={{ marginLeft: "10%" }} />
                          <CardContent style={{ textAlign: "left" }}>
                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>

                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                      <Card variant="outlined" sx={{ maxWidth: 500, marginRight: "16px", borderRadius: "8px" }}>
                        <CardActionArea>
                          <Skeleton animation="rectangular" height={170} width="80%" style={{ marginLeft: "10%" }} />
                          <CardContent style={{ textAlign: "left" }}>
                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>

                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                      <Card variant="outlined" sx={{ maxWidth: 500, marginRight: "16px", borderRadius: "8px" }}>
                        <CardActionArea>
                          <Skeleton animation="rectangular" height={170} width="80%" style={{ marginLeft: "10%" }} />
                          <CardContent style={{ textAlign: "left" }}>
                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>

                            <Typography component="div">
                              <Skeleton animation="wave" height={21} width="100%" />
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </Carousel>
                  )}
                </>
              )}

              <SpacerMely height={24} />

              {/* Recentes */}

              {isLogged && pedido ? (
                <>
                  {pedido.length !== 0 && (
                    <>
                      <Typography style={{ fontSize: "16px", color: "#1B1B1B", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                        <History style={{ color: "#1B1B1B", fontSize: "18px" }} />
                        &nbsp; Recentes
                      </Typography>

                      <SpacerMely height={12} />
                      {(JSON.parse(atob(pedido[0].detalhes))).map((detalhes) => (
                        <Card variant="outlined" sx={{ display: 'flex', borderRadius: "8px" }} onClick={() => handleSelectItem(detalhes.id)}>
                          <Box sx={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
                            <CardContent sx={{ flex: '1 0 auto' }}>

                              <Typography component="div" style={{ fontSize: "12px", color: "#1B1B1B", textOverflow: 'ellipsis', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical', overflow: 'hidden', display: '-webkit-box', alignItems: "center", fontWeight: "bold" }}>
                                {detalhes.nome}
                              </Typography>
                              <Typography style={{ fontSize: '12px', color: '#999', width: '100%', textOverflow: 'ellipsis', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical', overflow: 'hidden', display: '-webkit-box', maxHeight: '54px' }} component="div" dangerouslySetInnerHTML={{ __html: detalhes.descricao.replaceAll("\n", "<br/>") }}>
                              </Typography>
                            </CardContent>
                          </Box>
                          <p style={{ textAlign: "right", minWidth: "80px", margin: 0, marginBottom: "-5px" }}>
                            <CardMedia component="img" style={{ height: "100%", maxWidth: "140px" }} image={`${urlBase.replaceAll("/api", "")}/imagens-produtos/${detalhes.id}_0.png?${new Date().getTime()}`} onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = "https://dedicado.mely.online/imagens/placeholder.png";
                            }}
                            />
                          </p>
                        </Card>
                      ))}
                    </>
                  )}
                </>
              ) : (
                <>
                  <Typography style={{ fontSize: "16px", color: "#1B1B1B", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                    <History style={{ color: "#1B1B1B", fontSize: "18px" }} />
                    &nbsp; Recentes
                  </Typography>

                  <SpacerMely height={12} />
                  <Card variant="outlined" sx={{ display: 'flex', borderRadius: "8px" }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
                      <CardContent sx={{ flex: '1 0 auto' }}>

                        <Typography component="div" style={{ fontSize: "12px", color: "#1B1B1B", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                          <Skeleton animation="wave" height={21} width="100%" />
                        </Typography>
                        <Typography style={{ fontSize: '12px', color: '#999', width: '100%', textOverflow: 'ellipsis', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical', overflow: 'hidden', display: '-webkit-box', maxHeight: '54px' }} component="div">
                          <Skeleton animation="wave" height={21} width="100%" />
                        </Typography>
                      </CardContent>
                    </Box>
                    <p style={{ textAlign: "right", minWidth: "80px", margin: 0, marginBottom: "-5px" }}>
                      <Skeleton animation="rectangular" height={80} width="80%" />
                    </p>
                  </Card>
                </>
              )}
            </>
          )}

          <SwipeableDrawer
            container={container}
            anchor="bottom"
            open={open}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            disableSwipeToOpen={true}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {!isShare ? (
              <>
                <Box style={{ backgroundColor: "#D6D6D6", height: "4px", width: "32px", borderRadius: "100px", margin: "15px auto" }}></Box>

                <img alt="Banner" src={`${urlBase.replaceAll("/api", "")}/imagens/promo-banner.png?${new Date().getTime()}`} style={{ margin: "20px", borderRadius: "8px", maxHeight: "500px" }} />

                <Box sx={{ p: "20px" }}>
                  <ButtonMely variant="outlined" onClick={toggleDrawer(false)}>Fechar</ButtonMely>
                </Box>
              </>
            ) : (
              <>
                <Box style={{ backgroundColor: "#D6D6D6", height: "4px", width: "32px", borderRadius: "100px", margin: "15px auto" }}></Box>
                <Typography style={{ fontSize: "20px", textAlign: "center", fontWeight: "bold" }}>Compartilhe com seus amigos!</Typography>
                <SpacerMely height={20} />
                <Box style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Chip icon={<WhatsApp onClick={() => share(2)} style={{ color: "#FFF", fontSize: "30px", marginTop: "-3px" }} />} style={{ backgroundColor: "#25D366", color: "#FFF", borderRadius: "50%", height: "50px", width: "50px", paddingLeft: "14px" }} />
                  <SpacerMely width={20} />
                  <Chip icon={<Instagram onClick={() => share(3)} style={{ color: "#FFF", fontSize: "30px", marginTop: "-1px" }} />} style={{ backgroundColor: "#DD2A7B", color: "#FFF", borderRadius: "50%", height: "50px", width: "50px", paddingLeft: "14px" }} />
                  <SpacerMely width={20} />
                  <Chip icon={<Facebook onClick={() => share(1)} style={{ color: "#FFF", fontSize: "30px", marginTop: "-1px" }} />} style={{ backgroundColor: "#3B5998", color: "#FFF", borderRadius: "50%", height: "50px", width: "50px", paddingLeft: "14px" }} />
                  <SpacerMely width={20} />
                  <Chip icon={<Telegram onClick={() => share(4)} style={{ color: "#FFF", fontSize: "30px", marginTop: "-1px" }} />} style={{ backgroundColor: "#6CC1E3", color: "#FFF", borderRadius: "50%", height: "50px", width: "50px", paddingLeft: "10px" }} />
                  <SpacerMely width={20} />
                  <Chip icon={<LinkOutlined onClick={() => share(5)} style={{ color: "#FFF", fontSize: "30px", marginTop: "-1px" }} />} style={{ backgroundColor: `rgba(${colorPrimary})`, color: "#FFF", borderRadius: "50%", height: "50px", width: "50px", paddingLeft: "12px" }} />
                </Box>
                <SpacerMely height={40} />
              </>
            )}
          </SwipeableDrawer>
        </>
      }

      <SpacerMely height={100} />

    </Container>
  );
}

Home.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  windows: PropTypes.func,
};

export default Home;